// extracted by mini-css-extract-plugin
module.exports = {"disc":"e_Tk","accent":"e_Uk","empty":"e_Vk","s32":"e_Wk","s36":"e_Xk","s44":"e_Yk","s56":"e_Zk","s72":"e__k"};